export const productHighlights = [
  {
    name: "beacon",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      { iconName: "fluent:weather-blowing-snow-48-regular", spec: "20 Vents" },
      { iconName: "mdi:helmet", spec: "Adjustable Fit" },
      { iconName: "ph:headlights", spec: "LED Front & Tailight" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/beacon/Beacon_Blue+banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/beacon/Beacon_Blue+banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/beacon/Beacon_Orange+banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/beacon/Beacon_Orange+banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/beacon/Beacon_Yellow+banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/beacon/Beacon_Yellow+banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "How do vents make a difference in the rider experience?",
        answer:
          "Vents keep your head cool by allowing air to flow through the helmet as you ride. This helps prevent overheating and makes your ride much more comfortable, especially on hot days.",
      },
      {
        question: "How often should I replace my helmet?",
        answer:
          "You should replace your helmet after a crash, even if it looks fine. If you haven't had any accidents, it's a good idea to replace it every 2 years to ensure it still offers the best protection.",
      },
      {
        question: "How do I charge my lights?",
        answer:
          "Charging your helmet lights is easy. Simply connect the provided USB cable to the charging port on your helmet and plug it into a power source. The lights will be fully charged in 2-3 hours.",
      },
      {
        question: "Can I wash the inner lining?",
        answer:
          "Yes, you can wash the inner lining! Just remove it from the helmet and hand wash it with mild soap and water. Let it air dry completely before putting it back in.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "miniair",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "mdi:printer-3d-nozzle",
        spec: "Dual Valve Compatibility",
      },
      { iconName: "lets-icons:pressure-light", spec: "120 PSI" },
      {
        iconName: "lucide:gauge",
        spec: "Vibrant Gauge",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/miniair/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/miniair/banner2.png",
      ],
    ],
    faq: [
      {
        question: "What valves do EMotorad pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI. In case there is no gauge, you can manually check the tyre pressure by pressing on it.",
      },
      {
        question: "Can I use EMotorad pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "blazebeam",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "ph:headlights-fill",
        spec: "5 Light Modes",
      },
      { iconName: "uil:brightness", spec: "400 Lumens" },
      { iconName: "fluent:battery-10-32-regular", spec: "2000mAh Battery" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/blazebeam/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/blazebeam/banner2.png",
      ],
    ],
    faq: [
      {
        question: "How do I charge my e-cycle lights?",
        answer:
          "Most e-cycle lights are rechargeable using a USB cable. Simply plug the cable into the charging port on the light and connect it to a power source, like a computer or wall adapter.",
      },
      {
        question: "Can I use my lights in the rain?",
        answer:
          "Yes, most e-cycle lights are water-resistant, meaning they can be used in light to moderate rain. All have IPX5 and IPX6 ratings.",
      },
      {
        question: "Do EMotorad lights have different light settings?",
        answer:
          "Yes, all EMotorad lights come with five light modes such as half bright, full bright, breathing light, slow flash, and fast flash. ",
      },
      {
        question: "Do I need front and rear lights on my e-cycle?",
        answer:
          "Yes, it’s recommended to use both front and rear lights. A front light helps you see ahead, while a rear light makes you visible to others from behind, enhancing safety on the road.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "lumisafe",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      { iconName: "fluent:weather-blowing-snow-48-regular", spec: "18 Vents" },
      { iconName: "mdi:helmet", spec: "Adjustable Fit" },
      { iconName: "icon-park-outline:weight", spec: "Lightweight Design" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+Red/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+Red/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+Green/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+Green/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+Brown/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+Brown/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+White/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/lumisafe/Black+White/2.jpg",
      ],
    ],
    faq: [
      {
        question: "How do vents make a difference in the rider experience?",
        answer:
          "Vents keep your head cool by allowing air to flow through the helmet as you ride. This helps prevent overheating and makes your ride much more comfortable, especially on hot days.",
      },
      {
        question: "How often should I replace my helmet?",
        answer:
          "You should replace your helmet after a crash, even if it looks fine. If you haven't had any accidents, it's a good idea to replace it every 2 years to ensure it still offers the best protection.",
      },
      {
        question: "How do I charge my lights?",
        answer:
          "Charging your helmet lights is easy. Simply connect the provided USB cable to the charging port on your helmet and plug it into a power source. The lights will be fully charged in 2-3 hours.",
      },
      {
        question: "Can I wash the inner lining?",
        answer:
          "Yes, you can wash the inner lining! Just remove it from the helmet and hand wash it with mild soap and water. Let it air dry completely before putting it back in.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "trailarmour",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      { iconName: "fluent:weather-blowing-snow-48-regular", spec: "13 Vents" },
      { iconName: "mdi:helmet", spec: "Adjustable Fit" },
      { iconName: "icon-park-outline:weight", spec: "Lightweight Design" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/trailarmour/Black/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/trailarmour/Black/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/trailarmour/Black+Red/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/trailarmour/Black+Red/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/trailarmour/White/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/trailarmour/White/2.jpg",
      ],
    ],
    faq: [
      {
        question: "How do vents make a difference in the rider experience?",
        answer:
          "Vents keep your head cool by allowing air to flow through the helmet as you ride. This helps prevent overheating and makes your ride much more comfortable, especially on hot days.",
      },
      {
        question: "How often should I replace my helmet?",
        answer:
          "You should replace your helmet after a crash, even if it looks fine. If you haven't had any accidents, it's a good idea to replace it every 2 years to ensure it still offers the best protection.",
      },
      {
        question: "How do I charge my lights?",
        answer:
          "Charging your helmet lights is easy. Simply connect the provided USB cable to the charging port on your helmet and plug it into a power source. The lights will be fully charged in 2-3 hours.",
      },
      {
        question: "Can I wash the inner lining?",
        answer:
          "Yes, you can wash the inner lining! Just remove it from the helmet and hand wash it with mild soap and water. Let it air dry completely before putting it back in.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "locksafe",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "marketeq:secure",
        spec: "Secure Key Mechanism",
      },
      {
        iconName: "fluent:weather-partly-cloudy-day-16-regular",
        spec: "All-Weather Protection",
      },
      { iconName: "vaadin:line-h", spec: "Sturdy Iron Cable" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Lock+Safe/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Lock+Safe/2.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most Xcape e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "bikeguard",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "marketeq:secure",
        spec: "4-Digit Combination",
      },
      {
        iconName: "fluent:weather-partly-cloudy-day-16-regular",
        spec: "All-Weather Protection",
      },
      { iconName: "vaadin:line-h", spec: "Durable Iron Cable" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Bike+Guard/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Bike+Guard/2.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most Xcape e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "ultrasafe",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "marketeq:secure",
        spec: "5-Digit Combination",
      },
      {
        iconName: "fluent:weather-partly-cloudy-day-16-regular",
        spec: "All-Weather Protection",
      },
      { iconName: "lucide:triangle-right", spec: "Frame Mount" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Ultra+Safe/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Ultra+Safe/2.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most Xcape e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "jetflo",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:valve-outline-rounded",
        spec: "Triple Valve Compatibility",
      },
      { iconName: "lets-icons:pressure-light", spec: "120 PSI Pressure" },
      {
        iconName: "lucide:grip",
        spec: "Easy Foldable Base",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Jet+Flow/Green/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Jet+Flow/Green/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Jet+Flow/Orange/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Jet+Flow/Orange/2.jpg",
      ],
    ],
    faq: [
      {
        question: "What valves do Xcape pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI.",
      },
      {
        question: "Can I use Xcape pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "freeflo",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:valve-outline-rounded",
        spec: "Triple Valve Compatible",
      },
      { iconName: "lets-icons:pressure-light", spec: "160 PSI" },
      {
        iconName: "lucide:grip",
        spec: "Triad base",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Free+Flow/Yellow/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Free+Flow/Yellow/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Free+Flow/Red/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Free+Flow/Red/2.jpg",
      ],
    ],
    faq: [
      {
        question: "What valves do Xcape pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI.",
      },
      {
        question: "Can I use Xcape pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "maxflo",
    category: "xcape",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:valve-outline-rounded",
        spec: "Triple Valve Compatibility",
      },
      { iconName: "lets-icons:pressure-light", spec: "100 PSI Pressure" },
      {
        iconName: "lucide:grip",
        spec: "Single Foldable Base",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Max+Flow/Black/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Max+Flow/Black/2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Max+Flow/Red/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Max+Flow/Red/2.jpg",
      ],
    ],
    faq: [
      {
        question: "What valves do Xcape pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI.",
      },
      {
        question: "Can I use Xcape pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "foamlite",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "game-icons:foam",
        spec: "Ortho-Memory Foam",
      },
      { iconName: "line-md:water-off", spec: "Waterproof & Washable" },
      {
        iconName: "logos:fabric",
        spec: "Anti-slip Fabric",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Saddle+Seat+Cover/Saddle+Seat+Cover_Bottom+1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Saddle+Seat+Cover/Saddle+Seat+Cover_MainBanner.jpg",
      ],
    ],
    faq: [
      {
        question: "What makes the Foamlite Saddle Cover comfortable?",
        answer:
          "The Foamlite Saddle Cover is made with ortho-memory-foam, offering superior cushioning and support for a more comfortable ride.",
      },
      {
        question: "Is the saddle cover waterproof?",
        answer:
          "Yes, the Foamlite Saddle Cover is fully waterproof, protecting your seat from rain and moisture while ensuring a dry ride.",
      },
      {
        question: "Will the cover stay securely on my seat?",
        answer:
          "Absolutely! The cover is designed with anti-slip inner fabric, ensuring it stays in place even during long or bumpy rides.",
      },
      {
        question: "Can I wash the Foamlite Saddle Cover?",
        answer:
          "Yes, the saddle cover is washable, making it easy to clean and maintain for long-lasting use.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "metal-fender",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "codicon:coverage",
        spec: "Full Coverage",
      },
      {
        iconName: "fluent:weather-haze-24-regular",
        spec: "All Weather-Resistant",
      },
      {
        iconName: "material-symbols:done-all",
        spec: "Multi-ebike Compatibility",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Fender/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Fender/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "Do the mudguards provide full protection?",
        answer:
          "Yes, these mudguards are designed to offer full coverage, protecting you from dirt, water, and debris during your rides.",
      },
      {
        question:
          "Are the mudguards durable enough for tough weather conditions?",
        answer:
          "Absolutely! Crafted from high-quality metal, these mudguards are built to withstand all types of weather, offering reliable protection in rain, mud, and more.",
      },
      {
        question: "Are the mudguards lightweight despite being made of metal?",
        answer:
          "Yes, despite their sturdy metal construction, these mudguards are designed to be lightweight, ensuring they don't add unnecessary bulk to your bike while still providing excellent protection.",
      },
      {
        question: "Can I install the mudguards myself?",
        answer:
          "Yes, the mudguards are easy to install and come with instructions to help you set them up quickly and securely.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "carrier",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "mdi:weight-kg",
        spec: "Carries Upto 25kgs",
      },
      {
        iconName: "tabler:universe",
        spec: "Universal Size",
      },
      {
        iconName: "material-symbols:construction",
        spec: "Rugged Steel Construction",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Carrier/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Carrier/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "What is the maximum weight the carrier can hold?",
        answer:
          "The EMotorad adjustable steel carrier can support up to 25kg of weight, making it perfect for carrying gear on your rides.",
      },
      {
        question: "Is the carrier compatible with EMotorad models?",
        answer:
          "The carrier is designed to be compatible with various EMotorad models like the X1, X2, Trex Air, ST-X, Neo, and Legend 07. Always check the specific model to ensure proper fit.",
      },
      {
        question: "Can the carrier handle rough terrain?",
        answer:
          "Built from premium steel, the carrier is durable and sturdy enough to handle rough terrain and challenging rides while securely holding your items.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "fortknox-lock",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "game-icons:combination-lock",
        spec: "5-Digit Combination",
      },
      {
        iconName: "material-symbols-light:key-off-outline",
        spec: "Keyless Access",
      },
      {
        iconName: "fluent:weather-haze-24-regular",
        spec: "All-Weather Protection",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/fortknox+pro/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/fortknox+pro/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most EMotorad e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "miniair-jet",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "mdi:printer-3d-nozzle",
        spec: "Single Nozzle",
      },
      {
        iconName: "lets-icons:pressure-light",
        spec: "120 PSI Pressure",
      },
      {
        iconName: "file-icons:alloy",
        spec: "Aluminium Alloy Body",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/miniairjet/Mini+Air+Jet_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/miniairjet/Mini+Air+Jet_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "What valves do EMotorad pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI. In case there is no gauge, you can manually check the tyre pressure by pressing on it.",
      },
      {
        question: "Can I use EMotorad pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "airwave",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:valve-outline-rounded",
        spec: "Triple Valve Compatibility",
      },
      {
        iconName: "lets-icons:pressure-light",
        spec: "160 PSI Pressure",
      },
      {
        iconName: "lucide:grip",
        spec: "Metal Anti-skid Base",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airwave/Airwave+White/Air+Wave+White+Pump_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airwave/Airwave+White/Air+Wave+White+Pump_Bottom+1.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airwave/Airwave+green/Air+Wave+Green+Pump_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airwave/Airwave+green/Air+Wave+Green+Pump_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "What valves do EMotorad pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI. In case there is no gauge, you can manually check the tyre pressure by pressing on it.",
      },
      {
        question: "Can I use EMotorad pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "airflow",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:valve-outline-rounded",
        spec: "Triple Valve Compatibility",
      },
      {
        iconName: "lets-icons:pressure-light",
        spec: "120 PSI Pressure",
      },
      {
        iconName: "lucide:gauge",
        spec: "Precision Metre Gauge",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airflow/red/Air+Flow+Red_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airflow/red/Air+Flow+Red_Bottom+1.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airflow/black/Air+Flow+Black_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/airflow/black/Air+Flow+Black_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "What valves do EMotorad pump support?",
        answer:
          "Most of our pumps support Presta, Schrader, and Dunlop valves for versatile compatibility.",
      },
      {
        question: "How much pressure can the pump handle?",
        answer:
          "Depending on the model, pumps can handle pressures ranging from 100 PSI to 160 PSI. Always check the specific pump's PSI rating for the best performance.",
      },
      {
        question: "How do I know when I’ve reached the right pressure?",
        answer:
          "Many pumps feature a built-in gauge that shows the pressure as you pump. Simply check the gauge to reach your desired PSI. In case there is no gauge, you can manually check the tyre pressure by pressing on it.",
      },
      {
        question: "Can I use EMotorad pump for more than just bikes?",
        answer:
          "Yes, many of our pumps can be used to inflate sports equipment, motorbikes, and more, as long as they are compatible with the valves and pressure requirements.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "nexus",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "ph:headlights-fill",
        spec: "5 Light Modes",
      },
      {
        iconName: "uil:brightness",
        spec: "300 Lumens",
      },
      {
        iconName: "fluent:battery-10-32-regular",
        spec: "2000mAh Battery",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/nexus/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/nexus/2.jpg",
      ],
    ],
    faq: [
      {
        question: "How do I charge my e-cycle lights?",
        answer:
          "Most e-cycle lights are rechargeable using a USB cable. Simply plug the cable into the charging port on the light and connect it to a power source, like a computer or wall adapter.",
      },
      {
        question: "Can I use my lights in the rain?",
        answer:
          "Yes, most e-cycle lights are water-resistant, meaning they can be used in light to moderate rain. All have IPX5 and IPX6 ratings.",
      },
      {
        question: "Do EMotorad lights have different light settings?",
        answer:
          "Yes, all EMotorad lights come with five light modes such as half bright, full bright, breathing light, slow flash, and fast flash. ",
      },
      {
        question: "Do I need front and rear lights on my e-cycle?",
        answer:
          "Yes, it’s recommended to use both front and rear lights. A front light helps you see ahead, while a rear light makes you visible to others from behind, enhancing safety on the road.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "firefly",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "ph:headlights-fill",
        spec: "5 Light Modes",
      },
      {
        iconName: "uil:brightness",
        spec: "270 Lumens",
      },
      {
        iconName: "fluent:battery-10-32-regular",
        spec: "1200mAh Battery",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/firefly/1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/firefly/2.jpg",
      ],
    ],
    faq: [
      {
        question: "How do I charge my e-cycle lights?",
        answer:
          "Most e-cycle lights are rechargeable using a USB cable. Simply plug the cable into the charging port on the light and connect it to a power source, like a computer or wall adapter.",
      },
      {
        question: "Can I use my lights in the rain?",
        answer:
          "Yes, most e-cycle lights are water-resistant, meaning they can be used in light to moderate rain. All have IPX5 and IPX6 ratings.",
      },
      {
        question: "Do EMotorad lights have different light settings?",
        answer:
          "Yes, all EMotorad lights come with five light modes such as half bright, full bright, breathing light, slow flash, and fast flash. ",
      },
      {
        question: "Do I need front and rear lights on my e-cycle?",
        answer:
          "Yes, it’s recommended to use both front and rear lights. A front light helps you see ahead, while a rear light makes you visible to others from behind, enhancing safety on the road.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "radlite",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "ph:headlights-fill",
        spec: "5 Light Modes",
      },
      {
        iconName: "uil:brightness",
        spec: "7 Lumens",
      },
      {
        iconName: "fluent:battery-10-32-regular",
        spec: "500mAh Battery",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/radlite/Radlite+Light_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/radlite/Radlite+Light_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "How do I charge my e-cycle lights?",
        answer:
          "Most e-cycle lights are rechargeable using a USB cable. Simply plug the cable into the charging port on the light and connect it to a power source, like a computer or wall adapter.",
      },
      {
        question: "Can I use my lights in the rain?",
        answer:
          "Yes, most e-cycle lights are water-resistant, meaning they can be used in light to moderate rain. All have IPX5 and IPX6 ratings.",
      },
      {
        question: "Do EMotorad lights have different light settings?",
        answer:
          "Yes, all EMotorad lights come with five light modes such as half bright, full bright, breathing light, slow flash, and fast flash. ",
      },
      {
        question: "Do I need front and rear lights on my e-cycle?",
        answer:
          "Yes, it’s recommended to use both front and rear lights. A front light helps you see ahead, while a rear light makes you visible to others from behind, enhancing safety on the road.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "lumo",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "ph:headlights-fill",
        spec: "5 Light Modes",
      },
      {
        iconName: "uil:brightness",
        spec: "76 Lumens",
      },
      {
        iconName: "fluent:battery-10-32-regular",
        spec: "350mAh Battery",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Lumo+Light/Lumo+Light_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Lumo+Light/Lumo+Light_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "How do I charge my e-cycle lights?",
        answer:
          "Most e-cycle lights are rechargeable using a USB cable. Simply plug the cable into the charging port on the light and connect it to a power source, like a computer or wall adapter.",
      },
      {
        question: "Can I use my lights in the rain?",
        answer:
          "Yes, most e-cycle lights are water-resistant, meaning they can be used in light to moderate rain. All have IPX5 and IPX6 ratings.",
      },
      {
        question: "Do EMotorad lights have different light settings?",
        answer:
          "Yes, all EMotorad lights come with five light modes such as half bright, full bright, breathing light, slow flash, and fast flash. ",
      },
      {
        question: "Do I need front and rear lights on my e-cycle?",
        answer:
          "Yes, it’s recommended to use both front and rear lights. A front light helps you see ahead, while a rear light makes you visible to others from behind, enhancing safety on the road.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "flash-trail",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "ph:headlights-fill",
        spec: "5 Light Modes",
      },
      {
        iconName: "uil:brightness",
        spec: "9 Lumens",
      },
      {
        iconName: "fluent:battery-10-32-regular",
        spec: "500mAh Battery",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Flash+Trail+Light/Flash+Trail+Light_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Flash+Trail+Light/Flash+Trail+Light_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "How do I charge my e-cycle lights?",
        answer:
          "Most e-cycle lights are rechargeable using a USB cable. Simply plug the cable into the charging port on the light and connect it to a power source, like a computer or wall adapter.",
      },
      {
        question: "Can I use my lights in the rain?",
        answer:
          "Yes, most e-cycle lights are water-resistant, meaning they can be used in light to moderate rain. All have IPX5 and IPX6 ratings.",
      },
      {
        question: "Do EMotorad lights have different light settings?",
        answer:
          "Yes, all EMotorad lights come with five light modes such as half bright, full bright, breathing light, slow flash, and fast flash. ",
      },
      {
        question: "Do I need front and rear lights on my e-cycle?",
        answer:
          "Yes, it’s recommended to use both front and rear lights. A front light helps you see ahead, while a rear light makes you visible to others from behind, enhancing safety on the road.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "aeroshield",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      { iconName: "fluent:weather-blowing-snow-48-regular", spec: "19 Vents" },
      { iconName: "mdi:helmet", spec: "Adjustable Fit" },
      { iconName: "ph:headlights", spec: "Integrated Tailight" },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/aeroshield/Green/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/aeroshield/Green/banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/aeroshield/Red/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/aeroshield/Red/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "How do vents make a difference in the rider experience?",
        answer:
          "Vents keep your head cool by allowing air to flow through the helmet as you ride. This helps prevent overheating and makes your ride much more comfortable, especially on hot days.",
      },
      {
        question: "How often should I replace my helmet?",
        answer:
          "You should replace your helmet after a crash, even if it looks fine. If you haven't had any accidents, it's a good idea to replace it every 2 years to ensure it still offers the best protection.",
      },
      {
        question: "How do I charge my lights?",
        answer:
          "Charging your helmet lights is easy. Simply connect the provided USB cable to the charging port on your helmet and plug it into a power source. The lights will be fully charged in 2-3 hours.",
      },
      {
        question: "Can I wash the inner lining?",
        answer:
          "Yes, you can wash the inner lining! Just remove it from the helmet and hand wash it with mild soap and water. Let it air dry completely before putting it back in.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "fortknox-lite",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "game-icons:combination-lock",
        spec: "4-Digit Combination",
      },
      {
        iconName: "fluent:weather-haze-24-regular",
        spec: "All-Weather Protection",
      },
      {
        iconName: "vaadin:line-h",
        spec: "Flexible Cable",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Fortknox+light/FortKnox+Lite+Lock_Main+Banner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Fortknox+light/FortKnox+Lite+Lock+1.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most EMotorad e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "fortknox-plus",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "game-icons:combination-lock",
        spec: "4-Digit Combination",
      },
      {
        iconName: "fluent:weather-haze-24-regular",
        spec: "Weather-Resistant",
      },
      {
        iconName: "vaadin:line-h",
        spec: "Alloy Cable",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Fortknox+Plus/FortKnox+Plus_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Fortknox+Plus/FortKnox+Plus_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most EMotorad e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "keyguard",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:key-outline",
        spec: "Key System",
      },
      {
        iconName: "lucide:triangle-right",
        spec: "Frame Mount",
      },
      {
        iconName: "fluent:weather-haze-24-regular",
        spec: "All-Weather Protection",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Key+Guard/Key+Guard_MainBanner.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Key+Guard/Key+Guard_Bottom+1.jpg",
      ],
    ],
    faq: [
      {
        question: "Is a key or combination lock better for my e-cycle?",
        answer:
          "Both have their benefits. Combination locks offer convenience as you don’t need to carry a key, while key locks may provide slightly more security. It depends on your personal preference and how secure you need your bike to be.",
      },
      {
        question: "Can e-cycle locks be used in all weather conditions?",
        answer:
          "Yes, all our e-cycle locks come with thick PU coating to withstand various weather conditions like rain and heat. However, it’s best to store your lock in a dry place when not in use to prevent rust or damage over time.",
      },
      {
        question: "How often should I replace my e-cycle lock?",
        answer:
          "Replace your lock if it shows signs of wear, like fraying cables or a stiff mechanism. If it’s still in good shape, a lock can last for several years with proper care.",
      },
      {
        question: "How long is the cable on most e-cycle locks?",
        answer:
          "Cable lengths vary, but most EMotorad e-cycle locks have 1m long cables. This should be enough to secure your bike to a fixed object like a pole or rack.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "nrg-pro",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "icon-park-outline:weight",
        spec: "Lightweight Laptop Bag",
      },
      {
        iconName: "fluent:weather-haze-20-regular",
        spec: "Weather Protection",
      },
      {
        iconName: "material-symbols-light:usb",
        spec: "USB Charging Port",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/journeyman/1+(1).jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/journeyman/2+(1).jpg",
      ],
    ],
    faq: [
      {
        question: "Is the EMotorad backpack water-resistant?",
        answer:
          "Yes, the EMotorad backpack features a water-resistant cover and is made with breathable, waterproof material to protect your belongings from rain and dust.",
      },
      {
        question: "Does the backpack have a charging port for devices?",
        answer:
          "Yes, it comes with an integrated fast-charging USB and USB-C port, allowing you to easily charge your smart devices on the go.",
      },
      {
        question: "What size laptop can fit in the backpack?",
        answer:
          "The dedicated padded laptop pocket is designed to securely hold laptops, providing extra protection with a zippered compartment.",
      },
      {
        question: "Is the backpack comfortable to wear for long periods?",
        answer:
          "Absolutely. The backpack is designed with padded shoulder straps and a cushioned back for maximum comfort, making it ideal for long commutes or extended use.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "plastic-fender",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "codicon:coverage",
        spec: "Versatile Design",
      },
      {
        iconName: "fluent:weather-haze-24-regular",
        spec: "All Weather-Resistant",
      },
      {
        iconName: "material-symbols:done-all",
        spec: "Reflective Tapes",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Plastic+Fender/Grey/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Plastic+Fender/Grey/banner1.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Plastic+Fender/Red/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Plastic+Fender/Red/banner1.jpg",
      ],
    ],
    faq: [
      {
        question: "Do the mudguards provide full protection?",
        answer:
          "Yes, these mudguards are designed to offer full coverage, protecting you from dirt, water, and debris during your rides.",
      },
      {
        question:
          "Are the mudguards durable enough for tough weather conditions?",
        answer:
          "Absolutely! Crafted from high-quality plastic, these mudguards are built to withstand all types of weather, offering reliable protection in rain, mud, and more.",
      },
      {
        question: "Are the mudguards lightweight despite being made of metal?",
        answer:
          "Yes, despite its hard plastic construction, these mudguards are designed to be lightweight yet sturdy. It also comes with reflective tapes for added safety.",
      },
      {
        question: "Can I install the mudguards myself?",
        answer:
          "Yes, the mudguards are easy to install. Just open clip it on the seat post and tighten the nut.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "hydro-smart",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "tabler:device-airtag",
        spec: "AirTag Slot",
      },
      {
        iconName: "material-symbols:hdr-strong",
        spec: "Durable PC Material",
      },
      {
        iconName: "icon-park-outline:weight",
        spec: "Lightweight",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Black/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Black/banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Red/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Red/banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/White/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/White/banner2.jpg",
      ],
    ],
    faq: [
      {
        question:
          "Will the Apple AirTag be securely attached to the bottle cage?",
        answer:
          "Yes, the Hydro Smart bottle cage is engineered to securely house the Apple AirTag, ensuring it stays in place even during rough rides.",
      },
      {
        question: "Will the bottle cage fit any bicycle or e-bike?",
        answer:
          "The Hydro Smart bottle cage is designed to fit most standard bicycles and e-bikes. Its secure construction ensures your bottle stays in place even on rough terrain.",
      },
      {
        question: "Is the Hydro Smart bottle cage easy to install?",
        answer:
          "Yes, the Hydro Smart bottle cage is very easy to install using standard bottle cage mounts found on most bicycles and e-bikes.",
      },
      {
        question: "What material is the Hydro Smart bottle cage made of?",
        answer:
          "The bottle cage is built of durable polycarbonate, ensuring long-lasting use while maintaining a lightweight profile.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "cleaning-kit",
    category: "emotorad",
    meta: {
      title: "Buy X1 Electric Cycle EMotorad | 16% Off",
      description:
        "Buy the EMotorad X1 Electric Cycle with 16% discount. Buy now for a seamless blend of speed and sustainability.",
      canonicalTag: "https://www.emotorad.com/bikes/x1",
      range: {
        title:
          "Best Electric Bicycle for Men, Buy EMotorad X1 Electric Cycle at 16% Off!",
        description:
          "Buy the EMotorad X1, best electric cycle for men in India with 16% discount. Buy now for a seamless blend of speed and sustainability.",
        canonicalTag: "https://www.emotorad.com/bikes/range/x-factor",
      },
    },
    links: {
      amazon: "https://amzn.eu/d/bljyJP3",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "material-symbols-light:electric-bike-outline-sharp",
        spec: "Made for E-bikes",
      },
      {
        iconName: "material-symbols:hdr-strong",
        spec: "ic:sharp-done-all",
      },
      {
        iconName: "uil:smile",
        spec: "Easy-to-use",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Black/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Black/banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Red/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/Red/banner2.jpg",
      ],
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/White/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/bottle+cage/White/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "What types of e-bikes is this cleaning kit suitable for?",
        answer:
          "This cleaning kit is designed for all types of e-bikes, ensuring thorough maintenance regardless of brand or model.",
      },
      {
        question: "How often should I clean my e-bike with this kit?",
        answer:
          "It’s recommended to clean your e-bike after every few rides. Please follow the guidelines on the box to ensure proper application of each product and maximise the longevity and performance of your e-bike.",
      },
      {
        question: "Are the cleaning products eco-friendly?",
        answer:
          "Yes, the kit includes eco-friendly formulations, such as the Charcoal Bristle Brush, designed to minimise environmental impact while effectively cleaning your bike.",
      },
      {
        question: "How should I store the cleaning kit when not in use?",
        answer:
          "It’s best to store the cleaning kit in a cool, dry place, away from direct sunlight and extreme temperatures to maintain the effectiveness of the products.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "nimbus",
    category: "emotorad",
    links: {
      amazon: "",
      flipkart: "",
    },
    productSpecs: [
      {
        iconName: "icon-park-outline:weight",
        spec: "Weighs 240 grams",
      },
      {
        iconName: "ion:bicycle",
        spec: "Silicone Gel Cushion",
      },
      {
        iconName: "mingcute:dots-fill",
        spec: "Anti-skid Silicone Dots",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Nimbus/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Nimbus/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "1. How does the Nimbus Saddle Cover improve comfort?",
        answer:
          "The cover uses innovative cushioning technology that molds to your body, absorbing shocks and reducing pressure points for a smoother, more comfortable ride.",
      },
      {
        question: "2. Can I use the Nimbus Saddle Cover for long rides?",
        answer:
          "Yes, the cushioning technology is designed to provide comfort for both short and long rides, reducing discomfort from extended periods of sitting.",
      },
      {
        question: "3. Does the Nimbus Saddle Cover affect bike performance?",
        answer:
          "No, the Nimbus Saddle Cover is lightweight and designed not to interfere with your bike's performance, ensuring a smooth, comfortable ride without added bulk.",
      },
      {
        question: "4. Is the Nimbus Saddle Cover durable?",
        answer:
          "Yes, the cover is built with high-quality materials to provide long-lasting durability and maintain comfort over time.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "bliss",
    category: "xcape",
    links: {
      amazon: "https://www.amazon.in/dp/B0DZXF2X82",
      flipkart:
        "https://www.flipkart.com/xcape-bike-seat-cover-gel-padding-19-cm-wide-anti-skid-single-na/p/itm312e1c263dc31?pid=BSCHB758NGGFEH53",
    },
    productSpecs: [
      {
        iconName: "icon-park-outline:weight",
        spec: "Weighs only 300 grams",
      },
      {
        iconName: "ion:bicycle",
        spec: "Soft Sponge Foam & Gel",
      },
      {
        iconName: "mingcute:dots-fill",
        spec: "Anti-skid Silicone Dots",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Bilss/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Bilss/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "1. How does the Xcape Bliss Seat Cover improve comfort?",
        answer:
          "The seat cover combines soft sponge foam and gel, which absorbs shocks and reduces pressure on sensitive areas, making each ride smoother.",
      },
      {
        question: "2. How do I install the Xcape Bliss Seat Cover?",
        answer:
          "Simply slide the cover over your saddle and secure it with the adjustable straps for a snug fit.",
      },
      {
        question:
          "3. Can I use the Xcape Bliss Seat Cover for long-distance rides?",
        answer:
          "Yes, the cushioning design is ideal for both short commutes and long-distance cycling, providing comfort over extended periods.",
      },
      {
        question: "4. How do I clean the Xcape Bliss Seat Cover?",
        answer:
          "For cleaning, simply wipe the cover with a damp cloth. For deeper cleaning, you can hand-wash it with mild soap and let it air dry.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "switch",
    category: "emotorad",
    links: {
      amazon: "https://www.amazon.in/dp/B0DZHT4855",
      flipkart:
        "https://www.flipkart.com/emotorad-front-rear-pannier-rack-bike/p/itm845ee5ce709f8?pid=BNKHB72XGSE8VK7P",
    },
    productSpecs: [
      {
        iconName: "solar:case-linear",
        spec: "Back Hard Case",
      },
      {
        iconName: "material-symbols-light:expand",
        spec: "Expands to 29L",
      },
      {
        iconName: "material-symbols:devices-fold-2-outline",
        spec: "Folds Down to 17L",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Switch/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Switch/banner2.jpg",
      ],
    ],
    faq: [
      {
        question: "1. What bikes is the Switch Pannier Bag compatible with?",
        answer:
          "The Switch Pannier Bag is designed to fit most e-bikes and standard bicycles with rear racks. It's compatible with EMotorad models and many others that support pannier-style mounts.",
      },
      {
        question: "2. Can it be used as a regular backpack?",
        answer:
          "Absolutely! The bag converts into a backpack with shoulder straps, allowing you to carry it comfortably off the bike.",
      },
      {
        question: "3. How secure is the bag on the bike?",
        answer:
          "It attaches securely to your bike rack using sturdy mounting clips and adjustable straps, ensuring it stays in place even on bumpy roads or trails.",
      },
      {
        question: "4. Is the Switch Bag easy to install and remove?",
        answer:
          "Yes, the bag is designed for quick and hassle-free attachment and detachment, so you can switch between modes in seconds.",
      },
      {
        question: "5. Is the bag suitable for off-road use?",
        answer:
          "Yes, the Switch Bag is rugged and durable, making it suitable for both urban commutes and off-road cycling adventures.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
  {
    name: "touch",
    category: "xcape",
    links: {
      amazon: "https://www.amazon.in/dp/B0F2YVQTH1",
      flipkart:
        "https://www.flipkart.com/emotorad-x1-yellow-27-5-inches-single-speed-lithium-ion-li-ion-electric-cycle/p/itm37ad9bd2a6754",
    },
    productSpecs: [
      {
        iconName: "mynaui:mobile",
        spec: "Detachable Mobile Compartment",
      },
      {
        iconName: "fluent:auto-fit-32-light",
        spec: "Fits Phones up to 6.3 inches",
      },
      {
        iconName: "mdi:water-outline",
        spec: "Water and Stain Resistant",
      },
    ],
    lifestyleImages: [
      [
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Touch/banner1.jpg",
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/accessoryPage/Touch/banner2.jpg",
      ],
    ],
    faq: [
      {
        question:
          "1. Is the Xcape Touch Top Tube Bag compatible with all bikes?",
        answer:
          "Yes, the Xcape bag fits most bicycles, including road bikes, mountain bikes, and e-bikes, attaching securely to the top tube for easy access.",
      },
      {
        question: "2. Can I use my phone through the touch screen compartment?",
        answer:
          "Yes, the bag features a detachable touch-screen-compatible pouch, allowing you to use your phone for navigation, calls, or music without taking it out.",
      },
      {
        question: "3. Does the bag affect the bike’s handling or performance?",
        answer:
          "The bag is designed to be lightweight and aerodynamic, ensuring it doesn’t interfere with your bike’s handling or performance.",
      },
      {
        question: "4. How secure is the bag on the bike?",
        answer:
          "The bag attaches firmly to your bike’s top tube using strong Velcro straps, ensuring a stable and secure fit, even on rough terrain.",
      },
      {
        question: "5. How do I access items in the bag while riding?",
        answer:
          "The bag features quick-access pocket so you can easily grab your snacks, keys, or tools without stopping or fumbling around.",
      },
    ],
    reviews: {
      product: ["4.8", "700"],
    },
  },
];
